<template>
  <div v-if="[0, 1, 2, 3, 4, 5].includes(type)" class="type-wrap w-full">
    <img :src="pic" :class="isSelf ? 'h-[24px]' : 'h-[16px]'" alt="" />
  </div>
</template>

<script setup lang="ts">
import type0cn from '../img/type/tag-cn-00.webp';
import type1cn from '../img/type/tag-cn-01.webp';
import type2cn from '../img/type/tag-cn-02.webp';
import type3cn from '../img/type/tag-cn-03.webp';
import type4cn from '../img/type/tag-cn-04.webp';
import type5cn from '../img/type/tag-cn-05.webp';
import type0en from '../img/type/tag-en-00.webp';
import type1en from '../img/type/tag-en-01.webp';
import type2en from '../img/type/tag-en-02.webp';
import type3en from '../img/type/tag-en-03.webp';
import type4en from '../img/type/tag-en-04.webp';
import type5en from '../img/type/tag-en-05.webp';

const props = (defineProps<{
  isSelf?: boolean
  //type: 0-单牌 1-对子 2-顺子 3-同花 4-同花顺 5-三条
  type?: number
}>())
const $i18n = useNuxtApp().$i18n;
const sLang = computed(() => {
  return $i18n.locale.value;
});
const piccfg = {
  type0cn, type1cn, type2cn, type3cn, type4cn, type5cn,
  type0en, type1en, type2en, type3en, type4en, type5en,
}

const pic = computed(() => {
  return piccfg[`type${props.type}${sLang.value}`]
})
</script>

<style lang="scss" scoped>
.type-wrap {
  position: absolute;
  position: absolute;
  bottom: 0;
  z-index: 1;

  img {
    // object-fit: contain;
    margin: 0 auto;
  }
}
</style>